import * as React from 'react';
import { Typography } from 'onboarding-components';
import clsx from 'clsx';
import { SvgIconReact } from 'common/components/svg-icon';
import { useTranslation } from 'common/i18n/hooks';
import styles from '../index.module.styl';
type HeaderProps = {
  imgSrc: string;
  title: string;
  step: string;
  duration?: number;
  completed?: boolean;
};
export const Header = (_ref: HeaderProps) => {
  let {
    imgSrc,
    title,
    step,
    duration,
    completed
  }: HeaderProps = _ref;
  const {
    t
  } = useTranslation();
  return <div className={styles.header} data-sentry-component="Header" data-sentry-source-file="header.tsx">
      <div className={styles.title}>
        <img src={imgSrc} height={60} />
        <div>
          <Typography variant='eyebrowSm' className={styles.step} data-sentry-element="Typography" data-sentry-source-file="header.tsx">
            {step}
          </Typography>
          <Typography variant='headingSm' style={{
          margin: 0
        }} data-sentry-element="Typography" data-sentry-source-file="header.tsx">
            {title}
          </Typography>
        </div>
      </div>
      <Typography variant='bodySm' className={clsx(styles.time, {
      [styles.completed]: completed
    })} data-sentry-element="Typography" data-sentry-source-file="header.tsx">
        {completed ? <>
            <SvgIconReact icon={"checkmark"} color={"#07B096"} />
            {t("onboarding.completed")}
          </> : duration && <div>{t("onboarding.completion-duration", {
          count: duration
        })}</div>}
      </Typography>
    </div>;
};